import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magnetize/ba-genie/ba-genie-app/components/home-boxes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/builds/magnetize/ba-genie/ba-genie-app/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip","TooltipTrigger","TooltipContent"] */ "/builds/magnetize/ba-genie/ba-genie-app/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/builds/magnetize/ba-genie/ba-genie-app/node_modules/next/dist/client/app-dir/link.js");
